// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app-component/App";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@mui/material/CssBaseline";
import { Provider } from "react-redux";
import store from "./utils/redux/store";
import { ApolloProvider } from "@apollo/client";
import client from "./utils/graphql/apolloClient";
import { initAppCheck } from "./utils/firebase/app-check";
import { MathJaxContext } from "better-react-mathjax";
import { mathJaxConfig, mathJaxSrc } from "./utils/mathjax-config";
initAppCheck();
// Load wiris formula render script.
const jsDemoImagesTransform = document.createElement("script");
jsDemoImagesTransform.type = "text/javascript";
jsDemoImagesTransform.src =
  "https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image";
document.head.appendChild(jsDemoImagesTransform);
// This needs to be included before the '@wiris/mathtype-tinymce6' is loaded synchronously
window.tinymce = require("tinymce"); // Expose the TinyMCE to the window.
// Load wiris plugin synchronously.
require("@wiris/mathtype-tinymce6");

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CssBaseline />
      <ApolloProvider client={client}>
        <MathJaxContext config={mathJaxConfig} src={mathJaxSrc}>
          <App />
        </MathJaxContext>
      </ApolloProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
